var config = function (C) {
  C.APP_NAME = "retailer";
  C.userUrl = "/api/retailer/user";

  C.roles = [
    { id: "group_director", label: "Group Director" },
    { id: "retailer_admin", label: "Admin" },
    { id: "retailer", label: "Manager" },
    { id: "retailer_employee", label: "Employee" },
  ];

  C.containerTypes = [
    { type: "bottle", label: "Bottles" },
    { type: "can", label: "Cans" },
    { type: "keg", label: "Kegs" },
    { type: "other", label: "Other" },
  ];
  C.daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  C.nonDeliveryDistributors = ["Burke Bev"];
  C.MAX_DISTRIBUTORS_IN_SIDEBAR = 4;
  C.CREDIT_CARD_CAP = 1000;
  C.HAS_DISCOUNT_PRICING_DISTRIBUTOR_IDS = [
    171, 175, 182, 183, 248, 249, 251, 299, 336, 416, 418, 419, 420, 422, 424, 425, 428, 429, 430,
    431, 432, 435, 439, 441, 444, 447, 450, 463, 466, 469, 470, 471, 476, 480, 481, 482, 501, 550,
    570, 655, 662, 742, 763, 817, 818, 820, 823, 831, 845, 854, 855, 916, 917, 918, 920, 921, 922,
    923, 924, 947, 955, 956, 966, 969, 970, 971, 1002, 1034, 1040, 1047, 1048, 1057, 1059, 1095,
    1106, 1107, 1117, 1118, 1121, 1126, 1127, 1190, 1208, 1217, 1218, 1219, 1220, 1223, 1229, 1242,
    1245, 1246, 1248, 1249, 1251, 1252, 1254, 1255, 1283, 1312, 1313, 1316, 1317, 1319, 1320, 1321,
    1349, 1362, 1370, 1381, 1410, 1412, 1421, 1423, 1424, 1582, 1587, 1693, 1694, 1742, 1752, 2094,
    2130, 2164, 2247, 2414, 2419, 2423, 2550, 2610, 2623, 2626, 2628, 2629, 2630, 2631, 2632, 2633,
    2634, 2635, 2636, 2651, 2722, 2724, 2773, 2774, 2775, 2788, 2798, 2930, 2936, 2946, 2961, 2962,
    2963, 2964, 2965, 2966, 2967, 2982, 2984, 2985, 3062, 3070, 3080, 3081, 3083, 3084, 3088, 3090,
    3092, 3093, 3134, 3135, 3136, 3138, 3261, 3262, 3263, 3264, 3265, 3266, 3269, 3270, 3271, 3272,
    3273, 3274, 3275, 3277, 3281, 3283, 3284, 3285, 3286, 3287, 3289, 3290, 3291, 3293, 3295, 3296,
    3298, 3299, 3300, 3301, 3304, 3305, 3306, 3307, 3308, 3309, 3310, 3312, 3313, 3314, 3315, 3316,
    3318, 3319, 3321, 3322, 3323, 3325, 3326, 3329, 3330, 3331, 3332, 3333, 3334, 3335, 3338, 3343,
    3344, 3345, 3347, 3350, 3351, 3354, 3356, 3357, 3358, 3359, 3360, 3361, 3362, 3363, 3365, 3367,
    3368, 3370, 3371, 3372, 3373, 3374, 3375, 3376, 3377, 3378, 3379, 3383, 3384, 3385, 3386, 3387,
    3388, 3389, 3390, 3391, 3392, 3393, 3394, 3395, 3396, 3397, 3398, 3400, 3401, 3402, 3404, 3405,
    3406, 3407, 3409, 3410, 3411, 3414, 3415, 3416, 3418, 3421, 3422, 3423, 3424, 3425, 3428, 3430,
    3434, 3436, 3437, 3441, 3442, 3443, 3445, 3446, 3447, 3449, 3450, 3452, 3453, 3455, 3456, 3457,
    3458, 3459, 3460, 3461, 3463, 3464, 3465, 3466, 3468, 3469, 3470, 3473, 3475, 3476, 3477, 3479,
    3482, 3483, 3484, 3485, 3486, 3487, 3490, 3491, 3492, 3494, 3496, 3497, 3498, 3499, 3500, 3501,
    3503, 3504, 3505, 3506, 3507, 3508, 3509, 3510, 3512, 3514, 3515, 3516, 3517, 3519, 3520, 3523,
    3524, 3526, 4120, 4316, 4415, 4481, 4482, 4483, 4484, 4485, 4487, 4488, 4489, 4490, 4491, 4492,
    4494, 4495, 4497, 4499, 4500, 4502, 4505, 4506, 4507, 4508, 4509, 4510, 4511, 4513, 4514, 4515,
    4516, 4519, 4521, 4522, 4523, 4524, 4525, 4526, 4528, 4529, 4530, 4532, 4534, 4537, 4547, 4548,
    4550, 4551, 4552, 4555, 4580, 4581, 4583, 4643, 4644, 4645, 4646, 4648, 4651, 4653, 4654, 4655,
    4683, 4684, 4687, 4689, 4690, 4691, 4692, 4694, 4695, 4696, 4697, 4698, 4699, 4700, 4701, 4705,
    4706, 4708, 4709, 4710, 4712, 4714, 4715, 4717, 4718, 4719, 4720, 4721, 4724, 4725, 4727, 4728,
    4729, 4732, 4734, 4737, 4738, 4781, 4793, 4795, 4798, 4799, 4800, 4801, 4802, 4803, 4804, 4805,
    4807, 4808, 4810, 4811, 4813, 4821, 5316, 5317, 5318, 5321, 5323, 5336, 5337, 5338, 5341, 5342,
    5343, 5345, 5876, 5877, 5879, 5880, 5881, 5882, 5883, 5884, 5885, 5886, 5888, 5889, 5890, 5892,
    5893, 5894, 5895, 5896, 5897, 5898, 5899, 5900, 5901, 5903, 5904, 5905, 5906, 5909, 5912, 5913,
    5914, 5917, 6098, 6100, 6134, 6135, 6136, 6137, 6138, 6139, 6141, 6142, 6364, 6461, 6956, 7154,
    7593, 7781, 7979, 8012, 8705, 9794, 10388, 10817, 11123, 11180, 11213, 11345, 11444, 11576,
    11708, 11873, 13395, 16628, 17274, 18699,
  ];
  C.HAS_HOURLY_INVENTORY_UPDATES_DISTRIBUTOR_IDS = [254, 299, 818, 1106, 1107, 2628];
  C.HAS_DAILY_INVENTORY_UPDATES_DISTRIBUTOR_IDS = [
    171, 182, 183, 247, 248, 249, 251, 252, 253, 273, 302, 391, 393, 419, 421, 425, 427, 429, 430,
    431, 432, 439, 463, 466, 467, 470, 471, 474, 482, 507, 508, 548, 549, 550, 552, 562, 570, 742,
    763, 765, 819, 820, 831, 845, 854, 855, 916, 918, 920, 921, 924, 947, 951, 955, 956, 966, 969,
    971, 972, 979, 980, 1002, 1047, 1057, 1088, 1095, 1101, 1110, 1115, 1117, 1118, 1121, 1126,
    1127, 1190, 1201, 1207, 1208, 1209, 1217, 1218, 1219, 1220, 1223, 1251, 1252, 1255, 1312, 1320,
    1349, 1370, 1381, 1409, 1412, 1413, 1414, 1415, 1423, 1424, 1587, 1694, 1743, 1761, 2094, 2164,
    2415, 2424, 2427, 2550, 2610, 2623, 2633, 2649, 2788, 2961, 2962, 2963, 2966, 2999, 3070, 3090,
    3093, 3135, 3261, 3273, 3289, 3305, 3310, 3316, 3326, 3330, 3338, 3368, 3377, 3383, 3389, 3404,
    3406, 3466, 3491, 3494, 3501, 3503, 3506, 3523, 4485, 4510, 4523, 4643, 4647, 4722, 4725, 4726,
    4780, 4800, 4802, 4807, 4824, 5339, 5341, 5342, 5343, 5890, 5897, 5898, 5900, 5909, 8705, 16628,
    17096,
  ];
  C.HAS_WEEKLY_INVENTORY_UPDATES_DISTRIBUTOR_IDS = [
    655, 923, 952, 1242, 1316, 1317, 1319, 1430, 2413, 2626, 2635, 2775, 2798, 2946, 2965, 3062,
    3387, 3411, 3428, 3524, 4718, 5320, 5878, 6134, 9794,
  ];
  C.HAS_MONTHLY_INVENTORY_UPDATES_DISTRIBUTOR_IDS = [3307, 4799, 5884, 5895];
  C.NO_RECENT_INVENTORY_UPDATES_DISTRIBUTOR_IDS = [
    259, 310, 416, 420, 422, 423, 424, 428, 441, 444, 469, 481, 823, 1048, 1089, 1102, 1108, 1113,
    1211, 1245, 1246, 1248, 1249, 1286, 1321, 1410, 1421, 1582, 1693, 2130, 2630, 2632, 2636, 2651,
    2722, 2930, 2936, 2964, 2982, 2984, 3080, 3086, 3092, 3102, 3134, 3136, 3138, 3264, 3265, 3266,
    3269, 3281, 3284, 3285, 3290, 3300, 3301, 3308, 3333, 3334, 3335, 3351, 3361, 3363, 3367, 3372,
    3373, 3375, 3379, 3384, 3388, 3390, 3391, 3394, 3416, 3424, 3430, 3443, 3445, 3449, 3453, 3455,
    3457, 3459, 3468, 3470, 3477, 3482, 3485, 3486, 3487, 3490, 3492, 3493, 3498, 3504, 3507, 3517,
    3520, 4316, 4415, 4481, 4482, 4483, 4486, 4492, 4494, 4496, 4497, 4502, 4505, 4506, 4511, 4515,
    4518, 4519, 4529, 4530, 4537, 4548, 4549, 4550, 4580, 4644, 4645, 4687, 4713, 4715, 4717, 4719,
    4723, 4729, 4793, 4796, 4798, 4801, 4803, 4804, 4810, 4822, 4825, 5316, 5336, 5337, 5347, 5876,
    5877, 5879, 5881, 5883, 5885, 5886, 5887, 5889, 5894, 5896, 5901, 5904, 5905, 5908, 5911, 5912,
    5914, 6131, 6137, 6409, 7781, 10132, 10388, 10817, 11123, 11180, 11576, 11708, 13395, 17274,
    18699, 20069,
  ];
  window.C = C;
};

config.$inject = ["C"];

if (typeof tiz !== "undefined" && tiz.config) {
  tiz.config(config);
}

export default config;
